var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import style from './SideNote.scss';
var SideNote = function (_a) {
    var _b;
    var className = _a.className, bold = _a.bold, obscure = _a.obscure, disabled = _a.disabled, rest = __rest(_a, ["className", "bold", "obscure", "disabled"]);
    return (React.createElement("div", __assign({ className: classnames(style.SideNote, (_b = {},
            _b[style['SideNote--bold']] = bold,
            _b[style['SideNote--obscure']] = obscure,
            _b[style['SideNote--disabled']] = disabled,
            _b), className) }, rest)));
};
export default SideNote;
